
import React, { useEffect, useState } from 'react';
import backicon from "../../../../../Assets/icons/backIcon.svg";
import { useLocation, useNavigate } from 'react-router-dom';
import axiosInstance from '../../../../services/api/API';
import PhysicalStockin from '../PhysicalStock-in';
import ROUTES_NAVIGATION from '../../../../../routes/routes';
import Loader from '../../../../customComponents/CustomLoader';

const PhysicalStockingDetails = () => {

  const [ physicalStockTakingList, setPhysicalStockTakingList ] = useState([])
  const [ formData, setFormData ] = useState([])
  const [ stockTypesData, setStockTypesData ] = useState([])
  const navigate = useNavigate()
  const [ businessPartnerIdState, setBusinessPartnerIdState ] = useState(null)
  const token = localStorage.getItem("authToken");
  const [vendorId,setVendorId] = useState()
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const { data } = location.state || {};
  const PhysicalStockinId = data?.phystkin_id
  console.log("locationdata<><><>",data);
  
 useEffect(() => {
    fetchPhysicalStockTakingListEdit()
  },[])

  
  const fetchPhysicalStockTakingListEdit = async () => {
    try{
      setLoading(true)
      const response = await axiosInstance.get(`/physicalstocktake/edit/${data.phystkin_id}`,{
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
    })
    const fetchedData = response.data.data[0];
   
    console.log(fetchedData, "FETCHEDDATA")
    const transformedData = {
    vendor_id:fetchedData.vendor_id,
    trn_no:fetchedData.trn_no,
    trn_date:fetchedData.trn_date,
    ref_no:fetchedData.ref_no,
    ref_date:fetchedData.ref_date,
    trn_total:fetchedData.trn_total,
    business_partner_id:fetchedData.business_partner_id,
    }
    setFormData(transformedData)
    setVendorId(fetchedData?.vendor_id)
    setPhysicalStockTakingList(fetchedData)

    
    const stockTypes = response.data.data[0].stock_types
    console.log(stockTypes, "STOCKTYPES")
    
    setStockTypesData(stockTypes)
    const businesspartnerid = response.data.data[0]?.business_partner_id;
    setBusinessPartnerIdState(businesspartnerid)
    console.log(businesspartnerid, "PARTNERID")
    
    console.log(formData, "depatartment DATA")
  
  }catch(error){
      console.log(error)
    }
    finally{
      setLoading(false)
    }
  }

  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <div>
      <div className="" >
        <div style={{paddingBottom:"35px", borderBottom:"1px solid lightgray", padding:"35px"}}>
      <span style={{fontWeight:"300", fontSize:"12px", paddingBottom:"5px", color:"gray", paddingLeft:"15px"}}>Logistics / Physical Stock Taking / Physical Stock Taking Details</span>
      <div className="backbutton" onClick={()=>navigate(ROUTES_NAVIGATION.STOCKTAKING)} >
        <img src={backicon} alt="back" />
          <span className="backbtntitleDetails">  Physical Stock Taking Details</span>
          
      </div>
        </div>
        
        <div >
        <div className="" >
        <h5 style={{paddingLeft:"55px"}} className='mt-2 mb-2 header-details'>Vendor Details</h5>
          <div className="detail-grid" style={{ paddingBottom:"30px", borderBottom:"1px solid lightgray", paddingLeft:"57px", paddingTop:"15px"}}>
            <div className="details-item">
              <span className="details-label">Trans. No.</span>
              <span className="details-value"> {physicalStockTakingList.trn_no} </span>
             
            </div>
            <div className="details-item">
              <span className="details-label">Trans. Date</span>
              <span className="details-value">{physicalStockTakingList.trn_date} </span>
              
            </div>
            <div className="details-item">
              <span className="details-label">Vendor Name</span>
              <span className="details-value">{physicalStockTakingList.companyname} </span>
              
            </div>
            <div className="details-item">
              <span className="details-label">Ref. No.</span>
              <span className="details-value">{physicalStockTakingList.ref_no} </span>
             
            </div>
            <div className="details-item">
              <span className="details-label">Ref. Date</span>
              <span className="details-value">{physicalStockTakingList.ref_date} </span>
            </div>
            <div className="details-item">
              <span className="details-label">Trans. Amount</span>
              <span className="details-value">{physicalStockTakingList.trn_total} </span>
              
            </div>
          </div>

          <div style={{paddingTop:"14px"}}>
          <PhysicalStockin businessPartnerIdState={businessPartnerIdState} stockTypesData={stockTypesData} PhysicalStockinId={PhysicalStockinId } vendorId={vendorId} />
          </div>
        </div>
        </div>
      </div>
      </div>
      )}
    </div>
  )
}

export default PhysicalStockingDetails